import { createContext } from 'react';

interface AuthModalContextType {
  showAuthModal: () => void;
  hideAuthModal: () => void;
}

export const AuthModalContext = createContext<AuthModalContextType | null>(null);
